export const CATEGORY_TYPE_SEARCH_MODE = {
    SEARCH_BY_TEXT: 'search_by_text',
    SEARCH_BY_FLOOR: 'search_by_floor',
    SEARCH_BY_CATEGORY: 'search_by_category',
} as const;

export type CATEGORY_TYPE_SEARCH_MODE = (typeof CATEGORY_TYPE_SEARCH_MODE)[keyof typeof CATEGORY_TYPE_SEARCH_MODE];
